/*
 * Choosing a route on the contact page sets the enquiry subject.
 *
 * The page says so in visible copy, so this is a promise rather than a convenience.
 * `scripts/check-contact-routes.mjs` keeps the two lists able to agree; this makes them agree at
 * runtime, and says so out loud when they cannot.
 *
 * DELEGATED FROM THE DOCUMENT, matching assets/auto-close-details.js, so it needs no per-block
 * wiring and survives a section being re-rendered by the theme editor.
 *
 * ONLY THE ROUTE WITH NO DESTINATION IS A BUTTON. Routes that link to a real page are anchors and
 * never reach this file — see the comment in blocks/contact-route.liquid for why that matters.
 *
 * IT ANNOUNCES, AND THEN IT MOVES FOCUS. A sighted visitor watches the select change. Without the
 * live region a screen reader user is dropped into a form and told nothing about the field that was
 * filled in for them. Focus goes to the first empty field rather than to the select, because the
 * select is the part that no longer needs their attention.
 */
(function contactRoutes() {
  document.addEventListener('click', function (event) {
    const trigger = event.target instanceof Element ? event.target.closest('[data-contact-route]') : null;
    if (!trigger) return;

    const wanted = trigger.getAttribute('data-contact-route');
    const select = document.querySelector('[data-contact-subject]');
    if (!select || !wanted) return;

    const match = [...select.options].find((option) => option.value === wanted);

    // A route with no matching option is the exact drift gate:contact-routes exists to stop. If one
    // ever reaches a storefront, fail toward the form still being usable rather than toward a dead
    // button, and leave a reason in the console for whoever is looking.
    if (!match) {
      console.warn(`contact-routes: no subject option matches the route "${wanted}".`);
    } else {
      select.value = match.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));

      const status = document.querySelector('[data-contact-subject-status]');
      if (status) status.textContent = `Subject set to ${match.value}.`;
    }

    const form = select.closest('form');
    if (!form) return;

    const firstEmpty = [...form.elements].find(
      (element) =>
        element instanceof HTMLInputElement &&
        ['text', 'email', 'tel'].includes(element.type) &&
        element.value.trim() === ''
    );

    // `block: 'center'` rather than the default 'nearest': the theme has a sticky header and no
    // scroll-padding on the scroll root, and 'nearest' moves the minimum distance, which is how a
    // focused field ends up underneath the header (SC 2.4.11).
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const target = firstEmpty || select;
    target.focus({ preventScroll: true });
    target.scrollIntoView({ block: 'center', behavior: reduced ? 'auto' : 'smooth' });
  });
})();
